import { BaseProfileFieldsFragment } from 'graphql/generated'
import Link from 'next/link'
import { Avatar } from 'components/common/Avatars'
import { Typography } from 'components/common'
import ModalTrigger from 'components/common/ModalTrigger'
import { UserModal } from './UserModal'
import { PropsWithChildren } from 'react'

export type ComponentType = 'Link' | 'Modal'

interface IProps {
  profile: BaseProfileFieldsFragment
  component?: ComponentType
}

const UserListItem: React.FC<PropsWithChildren<IProps>> = ({
  profile,
  component = 'Modal',
  children
}) => {
  return (
    <div className="" title={`${profile.displayName}`}>
      {component === 'Modal' ? (
        <ModalTrigger
          trigger={onClick => (
            <div className="flex gap-2 items-center justify-between">
              <div
                onClick={onClick}
                className="flex-1 flex items-center space-x-1 cursor-pointer"
              >
                <Avatar
                  src={
                    profile.thumb && profile.thumb?.length > 0
                      ? (profile.thumb as string)
                      : undefined
                  }
                />
                <Typography>{profile.displayName}</Typography>
              </div>

              {children}
            </div>
          )}
        >
          <UserModal userId={profile.id} />
        </ModalTrigger>
      ) : (
        <Link
          target="_blank"
          className="block"
          href={`/profiles/${profile.id}`}
        >
          <Avatar
            src={
              profile.thumb && profile.thumb?.length > 0
                ? (profile.thumb as string)
                : undefined
            }
          />
          <Typography>{profile.displayName}</Typography>
        </Link>
      )}
    </div>
  )
}

export default UserListItem
